export const currentTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;